export default __webpack_public_path__ + "static/69-37b50c6ede5adeae832ed997fb4bba24.gif";